import { MouseEventHandler } from "react";
import { Course, day, defaultUrl } from "../../Scripts/misc";

interface Props {
  course: Course;
  signUp: Function
}

function CourseCard({ course, signUp }: Props) {
  return (
    <>
      <div className="col-md-6 mb-4">
        <div className="card">
          <img
            src={defaultUrl + course.image}
            className="card-img-top"
            alt={course.id + "-img"}
          />
          <div className="card-body">
            <h5 className="card-title">{course.name}</h5>
            <div className="card-info">
              <i className="fas fa-clock"></i>{" "}
              {course.startTime + " - " + course.endTime}
            </div>
            <div className="card-info">
              <i className="fas fa-calendar-alt"></i> {day(course.dayOfWeek)}
            </div>
            <div className="card-info">
              <i className="fas fa-calendar-alt"></i> {"Kapacita: " + course.totalSignedInStudents + "/" + course.capacity}
            </div>
            <div className="d-flex mt-3">
              <button
                className="btn btn-primary"
                data-toggle="modal"
                data-target={"#infoModal"+course.id}
              >
                Více info
              </button>

              {!course.currentUserSignedIn ? <button
                className="btn btn-secondary ml-2"
                data-toggle="modal"
                data-target="#confirmSignUpModal"
                onClick={() => {signUp(course)}}
              >
                Přihlásit se
              </button> 
              :
              <button type="button" className="btn btn-success ml-2">Přihlášen!</button>}


            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={"infoModal"+course.id}
        tabIndex={-1}
        aria-labelledby="infoModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header popup-header">
              <h2 className="modal-title" id="infoModalLabel1">
                {course.name}
              </h2>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body popup-content">
            <div className="popup-info">
                <p><strong>Učitel</strong><br/>{course.teacher}</p>
                <p><strong>Čas</strong><br/>{day(course.dayOfWeek) + " " + course.startTime + " - " + course.endTime}</p>
                <p><strong>Kapacita</strong><br/>{"Kapacita: " + course.totalSignedInStudents + "/" + course.capacity}</p>
                <p><strong>Popis</strong><br/>{course.description}</p>
            </div>
            <div className="popup-image center-align column">
                <img src={defaultUrl + course.image} alt={"Obrázek kroužku " + course.name}/>
                {course.pdf && <a href={course.pdf} style={{marginTop: "1vh"}}><button className="btn btn-info"><i className="bi bi-file-pdf" style={{margin: "5px"}}></i>PDF</button></a>}
            </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default CourseCard;
